var utils = require("./utils");

$.fn.ajaxChosenSelect = function () {
  var $this = $(this).filter(function () {
    return $(this).attr("data-url") !== undefined;
  });

  if ($this.length) {
    $this.each(function (index) {
      var $self = $(this);
      var url = $self.attr("data-url");
      var name = $self.attr("data-name");
      var selected = $self.attr("data-selected");

      var paramObject = _getQueryParamObject($self.attr("data-addQueryParam"));

      // TODO
      // why was this selected required?
      // if (selected) {
      var options = {
        url: url,
        data: paramObject,
        dataType: "JSON",
        type: "GET",
        elem: $self,
        selected: selected,
      };
      var promise = _ajaxCall(options);
      promise.done(_success);
      // }

      $self
        .closest(".js-expander")
        .children(".js-expander-handle")
        .one("click", function (e) {
          e.preventDefault(url);

          var options = {
            url: url,
            data: paramObject,
            dataType: "JSON",
            type: "GET",
            elem: $self,
          };
          var promise = _ajaxCall(options);
          promise.done(_success);
        });
    });
  }

  function _getQueryParamObject(name) {
    var paramObject = utils.getObjectFromQueryString(
      utils.getDecodedSafeQueryString(window.location.search),
    );

    if (!(name && paramObject)) return undefined;

    var obj = {};
    obj[name] = paramObject[name];

    return obj;
  }

  function _success(data) {
    var $self = this.elem;
    var options = [];

    if (data.bulkUpload) {
      options = _getBulkUploadList(data, name, this.selected); //chiich
    } else {
      options = _getOptionList(data, this.selected);
    }

    $self.append(options.join(""));
    $self.trigger("chosen:updated");
  }

  function _ajaxCall(options) {
    return $.ajax({
      url: options.url,
      data: options.data,
      dataType: options.dataType,
      type: options.type,
      elem: options.elem,
      selected: options.selected,
    });
  }

  function _getQueryStringObject(queryString) {
    var params = utils.getDecodedSafeQueryString(queryString);
    var windowSearchParams = utils.getObjectFromQueryString(params);

    var facet;
    for (facet in windowSearchParams) {
      $(
        '[name="' +
          facet +
          '"] option[value="' +
          windowSearchParams[facet] +
          '"]',
      ).prop("selected", true);
      $('[name="' + facet + '"]')
        .chosen()
        .change();
      $('[name="' + facet + '"]').trigger("chosen:updated");
    }
  }

  function _getOptionList(data) {
    var options = [];
    for (var key in data) {
      // skip loop if the property is from prototype
      if (!data.hasOwnProperty(key)) continue;
      options.push('<option value="' + key + '">' + data[key] + "</option>");
    }

    return options;
  }

  function _getBulkUploadList(data, name, selected) {
    var options = [];
    var text = "";
    var data = data.bulkUpload;
    var selectedText = "";

    if (data) {
      for (var key in data) {
        // skip loop if the property is from prototype
        if (!data.hasOwnProperty(key)) continue;
        selectedText = selected === data[key].bulkUploadId ? "selected" : "";
        text =
          data[key].username +
          " uploaded on " +
          utils.cleanDate(data[key].date);
        options.push(
          '<option value="' +
            data[key].bulkUploadId +
            '" ' +
            selectedText +
            ">" +
            text +
            "</option>",
        );
      }
    }

    return options;
  }
};
